"use client"
import { useLingui } from "@lingui/react/macro"

interface Props {
  className?: string
}

export function ShoppingCartIcon(props: Props) {
  const { t } = useLingui()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <title>{t`Shopping Cart Icon`}</title>
      <path
        d="M5.81416 17.0053C6.25599 17.0053 6.61416 16.6471 6.61416 16.2053C6.61416 15.7634 6.25599 15.4053 5.81416 15.4053C5.37233 15.4053 5.01416 15.7634 5.01416 16.2053C5.01416 16.6471 5.37233 17.0053 5.81416 17.0053Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.614 17.0053C15.0558 17.0053 15.414 16.6471 15.414 16.2053C15.414 15.7634 15.0558 15.4053 14.614 15.4053C14.1721 15.4053 13.814 15.7634 13.814 16.2053C13.814 16.6471 14.1721 17.0053 14.614 17.0053Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.0542 1.04492H2.6542L4.7822 10.9809C4.86026 11.3448 5.06274 11.6701 5.35477 11.9008C5.6468 12.1315 6.01012 12.2532 6.3822 12.2449H14.2062C14.5703 12.2443 14.9234 12.1195 15.207 11.8912C15.4907 11.6628 15.6879 11.3445 15.7662 10.9889L17.0862 5.04491H3.5102"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
